import { OnePlusNRollingOffer } from '@appcharge/shared-ui';

import { ETemplateStudioLayoutOptions, EThemes } from '../enums';

import { RollingOffersDesignsMetadata } from './types';

const defaultBuyOneGetMany: RollingOffersDesignsMetadata = {
  id: 'buyOneGetManyDefault',
  theme: EThemes.ROYAL_BLAST,
  version: '1.0.0',
  name: '1+Many',
  createdAt: '2026-05-03T00:00:00.000Z',
  isPrivate: false,
  previewAssets: [
    'https://media.appcharge.com/defaults/template-studio/rolling-offers/default_rolling_offers.png'
  ],
  layout: [
    ETemplateStudioLayoutOptions.HORIZONTAL,
    ETemplateStudioLayoutOptions.VERTICAL
  ],
  component: OnePlusNRollingOffer
};

export const buyOneGetManyDesigns = {
  defaultBuyOneGetMany
};

export const buyOneGetManyDesignsByTheme: Record<
  EThemes,
  RollingOffersDesignsMetadata[]
> = Object.values(buyOneGetManyDesigns).reduce(
  (acc, design) => {
    if (!acc[design.theme]) {
      acc[design.theme] = [];
    }
    acc[design.theme].push(design);
    return acc;
  },
  {} as Record<EThemes, RollingOffersDesignsMetadata[]>
);

export const buyOneGetManyDesignsById: Record<
  string,
  RollingOffersDesignsMetadata
> = Object.values(buyOneGetManyDesigns).reduce(
  (acc, design) => {
    acc[design.id] = design;
    return acc;
  },
  {} as Record<string, RollingOffersDesignsMetadata>
);
